<template>
  <div>
    <a-form-model ref="addInventoryTransferForm" :model="addInventoryTransferModel" :rules="rules">
      <a-row type="" justify="">
        <a-col :span="7" :offset="1">
          Purchase Order ID : {{ data.id }}
        </a-col>
        <a-col :span="7">
          SupplierName : {{ data.supplierName }}
        </a-col>
        <a-col :span="7">
          Created At : {{ displayDate(data.createdAt) }}
        </a-col>
      </a-row>
      <a-row type="" justify="">
        <div ref="productHeight" style="height: 400px; overflow-y: scroll; margin-top:40px;">
          <a-row v-for="(request, index) in addInventoryTransferModel.request" :key="request.key" type="flex"
            justify="space-around">
            <a-col :span="8">
              <a-form-model-item label="Product Name" :prop="'request.' + index + '.productId'" :rules="{
                required: true,
                message: 'Please choose your option',
                trigger: 'change',
              }">
                <a-input-number :min="1" class="rightSideinputText" type="text" v-model="request.productName"
                  disabled />

              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item label="Quantity" :prop="'request.' + index + '.quantity'" :rules="{
                required: true,
                message: 'Please enter your quantity',
                trigger: 'change',
              }">
                <a-input-number :min="1" class="rightSideinputText" type="number" :disabled="request.disabled"
                  v-model="request.quantity" />
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item label="Batch Number" :prop="'request.' + index + '.batchNumber'" :rules="{
                required: request.required,
                message: 'Please enter your number',
                trigger: 'change',
              }">
                <a-input class="rightSideinputText" :disabled="request.disabled" v-model="request.batchNumber" />
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="Batch Expiry" :prop="'request.' + index + '.batchExpiry'" :rules="{
                required: true,
                message: 'Please select your option',
                trigger: 'change',
              }">
                <a-date-picker class="rightSideinputText" v-model="request.batchExpiry" :disabled="request.disabled" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="!request.disabled" :span="2">
              <div style="
                        margin-top: 53px;
                        display: flex;
                        justify-content: space-around;
                      ">
                <a-tooltip>
                  <template slot="title">
                    Remove this order?
                  </template>
                  <a-icon v-if="addInventoryTransferModel.request.length > 0" class="dynamic-delete-button"
                    type="minus-circle-o" :disabled="addInventoryTransferModel.request.length === 0
                      " @click="removeDomain(request)" />
                </a-tooltip>

              </div>
            </a-col>
            <a-col v-if="request.disabled" :span="2">
              <div style="
                        margin-top: 53px;
                        display: flex;
                        justify-content: space-around;
                      ">
                <a-tooltip>
                  <template slot="title">
                    Add this order?
                  </template>
                  <a-icon v-if="addInventoryTransferModel.request.length > 0" type="plus" :disabled="addInventoryTransferModel.request.length === 0
                    " @click="activateDomain(request)" />
                </a-tooltip>

              </div>
            </a-col>
          </a-row>
        </div>
      </a-row>



      <a-row>
        <a-col :span="24">
          <a-form-model-item label="Notes" ref="notes" prop="notes">
            <a-textarea v-model="addInventoryTransferModel.notes" placeholder="Enter notes...."
              :auto-size="{ minRows: 3, maxRows: 5 }" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding-top: 40px;
                ">
        <a-button @click="handleAddInventoryTransfer" :disabled="isEmptyOrder"
          :class="[ isEmptyOrder ? 'disbablesBtn' : 'activeBtn' ]">
          Receive Purchase Order
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { NotificationMixins } from "@/mixins/NotificationMixins";
import moment from "moment";
import _ from "lodash";

    export default {
        name: 'ReceiveOrdersForm',
        mixins: [NotificationMixins],
        props: ['data'],
        data(){
            return{
                availableProducts:[],
                filteredProducts:[],
                availableDistCenters:[
                    {
                        
                    }
                ],
               
                tableLoading: false,
                addInventoryTransferModel:{
                    request:[
                        // {
                        //     productId:'',
                        //     quantity: '',
                        //     balance: 0,
                        //     key: Date.now()
                        // }
                    ],
                    notes: "",
                },
                purchaseDetails: this.data,
                rules: {
                    productId: [
                        { required: true, message: 'Please select your option', trigger: 'change' }
                    ],
                    quantity: [
                        { required: true, message: 'Please enter your quantity', trigger: 'change' },
                        {
                                pattern: new RegExp(/^[1-9]\d*$/),
                                message: 'Please enter valid number',
                                trigger: 'change'
                        },
                    ],
                    distributionCenterId: [
                        { required: true, message: 'Please select where your products will be transfered to', trigger: 'change' }
                    ],
                },
            }
        },
        methods:{
            ...mapActions(['getAllDistributionCenters', 'getAllInventoryProducts']),
            displayDate(date){
                return moment(date).format("DD-MM-YYYY") 
            },
            // addDomain() {
            //     this.$refs.addInventoryTransferForm.validate(valid => {
            //         if(valid){
            //             this.checkExistingProducts()
            //             if(this.filteredProducts.length !== 0) {
            //                 this.addInventoryTransferModel.request.push({
            //                     productId: '',
            //                     quantity: '',
            //                     disabled: false,
            //                     key: Date.now()
            //                 });
            //                 this.scrollToEnd();
            //             }
            //         }else{
            //             return false;
            //         }
            //     })
            // },
            scrollToEnd: function() { 
                const container = this.$refs.productHeight;
                container.scrollTop = container.scrollHeight;
            },
            removeDomain(item) {
                let index = this.addInventoryTransferModel.request.indexOf(item);
                if (index !== -1) {
                    // this.addInventoryTransferModel.request.splice(index, 1);
                    this.addInventoryTransferModel.request[index].disabled = true
                    this.addInventoryTransferModel.request[index].required = false
                }
                // this.checkExistingProducts();
            },
            activateDomain(item) {
                let index = this.addInventoryTransferModel.request.indexOf(item);
                if (index !== -1) {
                    // this.addInventoryTransferModel.request.splice(index, 1);
                    this.addInventoryTransferModel.request[index].disabled = false
                    this.addInventoryTransferModel.request[index].required = true
                }
                // this.checkExistingProducts();
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            
            // checkExistingProducts(){
            //     const selectedProducts = this.addInventoryTransferModel.request.map(product => product.productId)
            //     const products = [];
            //     this.availableProducts.forEach(product => {
            //         if(!(selectedProducts.includes(product.productId))){
            //             products.push(product)
            //         }
            //     })
            //     this.filteredProducts = products
            // },
            // onChangeProduct(request,productId){
            //     if(request.productId === productId){
            //         const product = this.filteredProducts.find(product => product.productId === productId)
            //         if(product){
            //             let index = this.addInventoryTransferModel.request.indexOf(request);
            //             let item = this.addInventoryTransferModel.request[index]
            //             item.balance = product.balance
            //             this.addInventoryTransferModel.request[index] = item
            //         }
            //     }
            // },
            handleAddInventoryTransfer(){
                this.$refs.addInventoryTransferForm.validate(valid => {
                    if (valid) {
                        let productQuantity = [];
                        const confirmedOrder = this.addInventoryTransferModel.request.filter(order => order.disabled === false)
                        // console.log("confirmedOrder | ", confirmedOrder)

                        confirmedOrder.forEach((product) => {
                            productQuantity.push({
                            productId: product.productId,
                            quantity: product.quantity,
                            batchNumber: product.batchNumber.toUpperCase(),
                            batchExpiry: moment(product.batchExpiry).format(),
                            });
                        });

                        const warehouse = JSON.parse(this.purchaseDetails.sellerAddress)
                        const request = {
                            id: warehouse?.destionation,
                            data: {
                                productLines: productQuantity,
                                notes: this.addInventoryTransferModel.notes,
                                clientPurchaseOrderId: this.purchaseDetails.id
                            },
                        };
                        this.$emit('inventoryRequest',request)       
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
           
            async loadAllDistributionCenters(response){
                if(response.status === 200){
                    this.availableDistCenters = await response.data.data
                }else{
                console.log("Error 2| " , response)
                }
            },
        
            preLoadOrder(){
                this.purchaseDetails = this.data
                console.log("purchaseDetails | ", this.purchaseDetails)
                this.addInventoryTransferModel.request = this.purchaseDetails.purchaseOrderLines.map(order => ({
                    productId: order.productId,
                    quantity: order.quantity,
                    batchNumber: "",
                    productName: order.productName,
                    batchExpiry: moment().format(),
                    disabled: false,
                    required: true,
                    key: order.productId,
                }))
            }
        },
        computed:{
            isEmptyOrder(){
                const confirmedOrder = this.addInventoryTransferModel.request.filter(order => order.disabled === false)
                return _.isEmpty(confirmedOrder)
            },
        },
        created() {
            // console.log("created")
          
        //   if(this.getAllStockAdjustmentData){
        //       this.getAllStockAdjustmentData();
        //   }
            if(this.preLoadOrder){
                this.preLoadOrder()
            }
            // if(this.loadInventoryProductsAndDistCenters){
            //     this.loadInventoryProductsAndDistCenters()
            // }
        },
        
        watch: {
        data: {
        immediate: true,
        handler(newValue) {
            this.purchaseDetails = newValue
        },
        },
    },
    }
</script>

<style lang="scss" scoped>
.disbablesBtn{
    color: rgba(0,0,0,.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    height:38px;
     border-raduis:5px; 
}
.activeBtn{
    height:38px;
    margin-right: 10px;
    border-raduis:5px; 
    background: #418a49; 
    color:#fff;
}

.rightSideinputText {
  width: 100%;
  border-radius: 5px;
}
</style>